// extracted by mini-css-extract-plugin
module.exports = {"notification":"UpdateNotification_notification__2QFC6"};